export const colours = {
  white: '#fff',
  black: '#393737',
  navy: '#7483B3',
  pink: '#FFD5E7',
  blue: '#C0D4F6',
  peach: '#FDA5A4',
  darkPeach: '#fd7b8a'
}
